export const formatDashString = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1).replace(/[-_]/g, ' ')
}